// @flow
import React, { type Node } from 'react';
import classnames from 'classnames';
import invariant from 'invariant';

import stylesheet from './Strap.scss';

const asTypes = {
  'solid-teal': 'solid-teal',
  'solid-neutral-light-1000': 'solid-neutral-light-1000',
};

type AsType = $Keys<typeof asTypes>;

type Props = {|
  children: Node,
  /** Available as: 'solid-teal' | 'solid-neutral-light-1000' */
  as: AsType,
  /** Available border: 'top' | 'bottom' */
  border?: 'top' | 'bottom',
|};

const Strap = ({ children, as, border = '' }: Props) => {
  invariant(
    asTypes[as],
    'You must specify a valid value for the "as" prop when rendering a Strap'
  );

  const strapClass = classnames(stylesheet.strap, stylesheet[`strap--${as}`], {
    [stylesheet[`strap--border-${border}`]]: border,
  });

  return <div className={strapClass}>{children}</div>;
};

export default Strap;
